import { render, staticRenderFns } from "./JobRole.vue?vue&type=template&id=47501fc4&scoped=true&"
import script from "./JobRole.vue?vue&type=script&lang=js&"
export * from "./JobRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47501fc4",
  null
  
)

export default component.exports